import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LoginService } from 'src/app/Common/Services/login.service';
import { HttpHeaders } from '@angular/common/http';
import { MatDialog } from '@angular/material';
import { LoginComponent } from '../login/login.component';
import { ToastrService } from 'ngx-toastr';
import { QuoteService } from 'src/app/Modules/motor/Modules/quote/Services/quote.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {

  selected = 'ENG';

  contactform:FormGroup;
  
  constructor(private _formbuilder: FormBuilder,public loginservice:LoginService,private toastr: ToastrService,public dialog: MatDialog,private quoteService:QuoteService) {

    

    this.contactform =this._formbuilder.group({
      name:['',[Validators.required]],
      mobile:['',[Validators.required,Validators.pattern('^(0|[0-9][0-9]*)$')]],
      email:['',[Validators.email,,Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
      message:['',[Validators.required]]
    })
   }
   openLoginDialog(): void {
    const dialogRef = this.dialog.open(LoginComponent, {
        panelClass: 'loginpopupbox'
    });
  }
  ngOnInit() {
    
    //to unlock the QQ
    
    var unlock = sessionStorage.getItem('LOCK');
    if(unlock =="L"){
      
      var userName =sessionStorage.getItem('userName');
      this.quoteService.unlockQuotedetails(userName).subscribe((data:any)=>{
        
        console.log(data);
      })
    }
  //END
  }

  submit(contactform){
    
    if(this.contactform.valid){
    let Form = JSON.stringify(this.contactform.value);
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    this.loginservice.contact(Form).subscribe((res: any)=>{
      console.log(res);
        
        if(res.responseBody){
          this.toastr.success(res.responseBody.validationMsg, undefined, {
            positionClass: 'toast-bottom-right',
            timeOut: 6000
       });
        }
    })
    }
    this.contactform.reset();
  }

  mobileChange(){
    
    var str = this.contactform.value.mobile.slice(0, 1);
    if(str !== "5"){
      this.contactform.patchValue({  
        mobile:""
      });
      this.toastr.error("Mobile number should start with number 5", undefined, {
        positionClass: 'toast-bottom-right',
        timeOut: 6000
   });
    }
    else if(this.contactform.value.mobile == "" || this.contactform.value.mobile == undefined) {
      this.contactform.patchValue({  
        mobile:""
      });
      this.toastr.error("Please Enter MobileNo", undefined, {
        positionClass: 'toast-bottom-right',
        timeOut: 6000
   });
     }
  }


}
